module.exports = __webpack_public_path__ + "fonts/5cb7edf.woff";